export const FormPartsValidationStatuses = {
  warning: 'WARNING', // this is the validation that still allow user submission
  error: 'ERROR', // this is the validation that will block user submission
} as const;
